import { Component } from "@angular/core";
import { DraftForm, DraftFormChanged, DraftFormType, FC_A, FC_G } from "src/app/modules/ngx-draft";
import { IFrontendUser } from "../../contract.interfaces";
import { ContactType, IContact } from "@vierkant-software/types__api";
import { Option } from "src/util/types/global";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";

@Component({
    templateUrl: './external-partner.step.haml',
    standalone:  false
})
export class ExternalPartnerStep {
    @DraftForm() form: DraftFormType<IFrontendUser>;

    public get contacts(){
        return this.form.get('contacts') as FC_A<IContact>;
    }

    public isEGYMEdit() {
        return this.egym.get('email').enabled;
    }

    public get isEGYMEnabled(){
        return this.form.get('enableEGYM').value;
    }

    public get egym(){
        return this.form.get('externalPartnerData.egym') as FC_G<IFrontendUser['externalPartnerData']['egym']>;
    }

    public emailOptions: Option<string> [] = [];

    public get isLinked() {
        const emailControl = this.egym.get('email');
        const {value: email, touched} = emailControl;
        return this.isEGYMEnabled && email?.length && !touched;
    }

    public get chip() {
        const emailControl = this.egym.get('email');
        const {value: email, touched} = emailControl;

        if (this.isEGYMEnabled) {
            if (touched || !email?.length)
                return ({ color: "Warning", label: _('EXTERNAL_PARTNER.EGYM.USER.LINKING')});

        } else {
            if (email?.length)
                return ({ color: "Warning", label: _('EXTERNAL_PARTNER.EGYM.USER.UNLINK')});
            else
                return ({ color: "Danger", label: _('EXTERNAL_PARTNER.EGYM.USER.UNLINKED')});
        }
    }

    constructor(){
    }

    onResolve(){
        // Add currently selected email to options to prevent users changing it in another step
        const emailDict =  [...this.contacts.value, {value: this.egym.value.email, type: ContactType.EMail} as IContact]
            .filter(contact => contact.type === ContactType.EMail && contact.value)
            .reduce((acc, contact) => {
                acc[contact.value] = { value: contact.value, label: contact.value };
                return acc;
            }, {} as Record<string, Option<string>>);
        this.emailOptions = Object.values(emailDict);

        if (this.egym.get('email').value)
            this.egym.get('email').disable();
    }

    @DraftFormChanged(['enableEGYM'])
    _onLinkedToEGYMChanged(){
        if (this.isEGYMEnabled) {
            const email = this.getPrimaryEmail();
            this.egym.get('email').setValue(email);
            this.egym.get('email').markAsTouched();
        }
        // Do **NOT** clear the email field to allow the user to re-enable EGYM in the same draft
    }

    public enableEGYMEmailChange(){
        this.egym.get('email').enable();
    }

    /**
     * Fetches the first primary email of the user's contacts 
     * @returns primaryEmail value
     */
    private getPrimaryEmail(){
        const contacts = this.contacts.value as IContact[];
        const primaryEmail = contacts.find(contact => contact.type === ContactType.EMail && contact.isPrimary);
        return primaryEmail?.value;
    }
}
